module.exports = __webpack_public_path__ + "img/purple-accent.3dbe3275.svg";